import { Editor } from '@tiptap/core';
import { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { AddButton } from './components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  position: number;
  editor: Editor;
}
export type CommandPickerTriggerRef = {
  updatePosition: (position: number) => void;
};

export const CommandsPickerTrigger = forwardRef<CommandPickerTriggerRef, Props>(
  ({ position: initialPosition, editor }, ref) => {
    const [position, setPosition] = useState(initialPosition);
    const addPlaceholder = useCallback(() => {
      editor.chain().focus().addCommandTriggerPlaceholder(position).run();
    }, [editor, position]);

    useImperativeHandle(ref, () => ({
      updatePosition: (position: number) => {
        setPosition(position);
      },
    }));

    return (
      <Wrapper>
        <AddButton onClick={addPlaceholder} />
      </Wrapper>
    );
  },
);

CommandsPickerTrigger.displayName = 'CommandsPickerTrigger';
